module.exports = __webpack_public_path__ + "media/images/brussels_page/logo3-a054d9b5e254e4d4b645084626b2eb72.svg";